import React from 'react';
import PropTypes from 'prop-types';

import './OverlayHeader.scss';

function LeftOverlayHeader({children}) {
  return <div className="overlay-header-left">{children}</div>;
}

function CenterOverlayHeader({children}) {
  return <div className="overlay-header-center">{children}</div>;
}

function RightOverlayHeader({children}) {
  return <div className="overlay-header-right">{children}</div>;
}

function OverlayHeader({children}) {
  return (
    <>
      <div className="overlay-header">{children}</div>
      <div className="overlay" />
    </>
  );
}

LeftOverlayHeader.propTypes = {
  children: PropTypes.any.isRequired,
};

CenterOverlayHeader.propTypes = {
  children: PropTypes.any.isRequired,
};

RightOverlayHeader.propTypes = {
  children: PropTypes.any.isRequired,
};

OverlayHeader.propTypes = {
  children: PropTypes.any.isRequired,
};

OverlayHeader.Left = LeftOverlayHeader;
OverlayHeader.Center = CenterOverlayHeader;
OverlayHeader.Right = RightOverlayHeader;

export default OverlayHeader;
